
import * as React from 'react';
import {AiOutlineHome, AiOutlineShop, AiOutlineShoppingCart, AiOutlineUser} from "react-icons/ai";
import {Link, useLocation} from "react-router-dom";

import './style.scss';
import WebPaths from "@router/paths/web";
import PanelPaths from "@router/paths/panel";



export function Index({token , login , isAdmin , count}) {
    const {pathname} = useLocation();
    return (
        <>
            <div>
                <div className='access-bar-down'>
                    <Link to={WebPaths.home} className={pathname === WebPaths.home ? 'access-bar-down-activeColor' : 'access-bar-down-item'}>
                        <AiOutlineHome/>
                        <p>صفحه اصلی</p>
                    </Link>
                    <Link  to={WebPaths.products()} className={pathname === WebPaths.products() ? 'access-bar-down-activeColor' : 'access-bar-down-item'}>
                        <AiOutlineShop/>
                        <p>محصولات</p>
                    </Link>
                    {
                        !token ? <div id='div-bottom-icons'
                                     className={pathname === '/authorize' ? 'access-bar-down-activeColor' : 'access-bar-down-item'}
                                     onClick={login}>
                            <AiOutlineUser/>
                            <p>ورود</p>
                        </div> :   <Link to={PanelPaths.dashboard}
                                         className={pathname === PanelPaths.dashboard ? 'access-bar-down-activeColor' : 'access-bar-down-item'}>
                            <AiOutlineUser/>
                            <p>داشبورد</p>
                        </Link>
                    }

                    {
                        !isAdmin &&
                        <Link to={WebPaths.cart}
                              className={pathname === WebPaths.cart ? 'access-bar-down-activeColor' : 'access-bar-down-item'}>
                        <span className='circle-price'>{count ? count : '0'}</span>
                            <AiOutlineShoppingCart/>
                            <p>سبد خرید</p>
                        </Link>
                    }

                </div>

            </div>
        </>
    );
};